import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Integrations } from "@dreamhub/designsystem/icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from "@/components/ui/breadcrumb";
import IconContainer from "@/components/ui/icon-container";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import Text from "@/components/ui/text";
import { INTEGRATIONS_TRANSLATION_PREFIX } from "@/pages/settings/components/integrations/integrations";

interface IntegrationsTopBarProps {
  /** Name of the open integration; omitted on the list page. */
  current?: string;
}

const IntegrationsTopBar: React.FC<IntegrationsTopBarProps> = ({ current }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const title = t(`${INTEGRATIONS_TRANSLATION_PREFIX}.title`);

  return (
    <div className="flex h-11 w-full items-center gap-1 border-b border-border-badge-chip-default px-2 py-[6px]">
      <LogoIconContainer
        index={-1}
        icon={<Integrations />}
        iconSize="5"
        className="h-7 w-7 rounded-lg"
        innerClassName="rounded-lg"
      />
      <Breadcrumb>
        <BreadcrumbList className="gap-0 sm:gap-0">
          <BreadcrumbItem>
            {current ? (
              <button
                type="button"
                className="rounded px-1 py-0.5"
                onClick={() => navigate("/settings/integrations")}
                data-test="integration-details-breadcrumb-root"
              >
                <Text
                  as="span"
                  variant="bodySecondary"
                  className="hover:text-primary"
                >
                  {title}
                </Text>
              </button>
            ) : (
              <BreadcrumbPage className="cursor-default px-1 py-0.5">
                <Text as="span" variant="body">
                  {title}
                </Text>
              </BreadcrumbPage>
            )}
          </BreadcrumbItem>
          {current && (
            <>
              <BreadcrumbSeparator className="p-0.5">
                <IconContainer size="sm" color="secondary">
                  <ChevronRight />
                </IconContainer>
              </BreadcrumbSeparator>
              <BreadcrumbItem>
                <BreadcrumbPage className="cursor-default px-1 py-0.5">
                  <Text as="span" variant="body">
                    {current}
                  </Text>
                </BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default IntegrationsTopBar;
